export const productModelE = {
    V3_5000_805: {
        value: 805,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_805',
    },
    V3_6000_806: {
        value: 806,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_806',
    },
    V3_18000_807: {
        value: 807,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_807',
    },
    V6_5000_811: {
        value: 811,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_811',
    },
    V6_5000_812: {
        value: 812,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_812',
    },
    V6_6000_813: {
        value: 813,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_813',
    },
    V6_6000_814: {
        value: 814,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_814',
    },
    V6_8000_815: {
        value: 815,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_815',
    },
    V6_8000_816: {
        value: 816,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_816',
    },
    V6_18000_817: {
        value: 817,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_817',
    },
    V6_18000_818: {
        value: 818,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_818',
    },
    V6_3000_819: {
        value: 819,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_819',
    },
    V6_5000_821: {
        value: 821,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_821',
    },
    V6_6000_822: {
        value: 822,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_822',
    },
    V6_8000_823: {
        value: 823,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_823',
    },
    V6_18000_824: {
        value: 824,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_824',
    },
    V6_5300_825: {
        value: 825,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_825',
    },
    V6_5500_826: {
        value: 826,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_826',
    },
    V6_5600_827: {
        value: 827,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_827',
    },
    V6_5800_828: {
        value: 828,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_828',
    },
    V6_6800_829: {
        value: 829,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_829',
    },
    V6_18500_830: {
        value: 830,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_830',
    },
    V6_18800_831: {
        value: 831,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_831',
    },
    V6_18800_832: {
        value: 832,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_832',
    },
    V6_5310_833: {
        value: 833,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_833',
    },
    V6_5500_834: {
        value: 834,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_834',
    },
    V6_5600_835: {
        value: 835,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_835',
    },
    V6_6800_836: {
        value: 836,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_836',
    },
    V6_18500_837: {
        value: 837,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_837',
    },
    V6_18800_838: {
        value: 838,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_838',
    },
    V6_5600k_839: {
        value: 839,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_839',
    },
    V6_18500K_840: {
        value: 840,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_840',
    },
    V6_5000_841: {
        value: 841,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_841',
    },
    V6_6000_842: {
        value: 842,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_842',
    },
    V6_5300K_844: {
        value: 844,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_844',
    },
    V6_5500K_845: {
        value: 845,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_845',
    },
    V6_1300_846: {
        value: 846,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_846',
    },
    v6_1300_864: {
        value: 864,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_864',
    },
    V6_1500_847: {
        value: 847,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_847',
    },
    V6_1500_865: {
        value: 865,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_865',
    },
    V6_1500T_862: {
        value: 862,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_862',
    },
    V6_1600_860: {
        value: 860,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_860',
    },
    V6_1600T_863: {
        value: 863,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_863',
    },
    V7_1610_866: {
        value: 866,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_866',
    },
    V7_1610T_867: {
        value: 867,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_867',
    },
    V6_5000_900: {
        value: 900,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_900',
    },
    V6_5000_901: {
        value: 901,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_901',
    },
    V6_6000_902: {
        value: 902,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_902',
    },
    V6_6000_903: {
        value: 903,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_903',
    },
    V6_8000_904: {
        value: 904,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_904',
    },
    V6_8000_905: {
        value: 905,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_905',
    },
    V6_18000_906: {
        value: 906,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_906',
    },
    V6_18000_907: {
        value: 907,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_907',
    },
    V6_3000_908: {
        value: 908,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_908',
    },
    V6_5000_909: {
        value: 909,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_909',
    },
    V6_6000_910: {
        value: 910,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_910',
    },
    V6_8000_911: {
        value: 911,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_911',
    },
    V6_18000_912: {
        value: 912,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_912',
    },
    V6_5300_913: {
        value: 913,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_913',
    },
    V6_5500_914: {
        value: 914,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_914',
    },
    V6_5600_915: {
        value: 915,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_915',
    },
    V6_5800_916: {
        value: 916,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_916',
    },
    V6_6800_917: {
        value: 917,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_917',
    },
    V6_18500_918: {
        value: 918,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_918',
    },
    V6_18800_919: {
        value: 919,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_919',
    },
    V6_18800_920: {
        value: 920,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_920',
    },
    V6_5600k_921: {
        value: 921,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_921',
    },
    V6_2100_922: {
        value: 922,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_922',
    },
    V6_5310_923: {
        value: 923,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_923',
    },
    V6_5510_924: {
        value: 924,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_924',
    },
    V6_2020_925: {
        value: 925,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_925',
    },
    V6_A300_926: {
        value: 926,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_926',
    },
    V7_A800_927: {
        value: 927,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_927',
    },
    V6_x8000_1200: {
        value: 1200,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1200',
    },
    V6_x9000_1201: {
        value: 1201,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1201',
    },
    V6_A8000_1202: {
        value: 1202,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1202',
    },
    V6_A9000_1203: {
        value: 1203,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1203',
    },
    V6_A6000_1204: {
        value: 1204,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1204',
    },
    V6_X6000_1205: {
        value: 1205,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1205',
    },
    V6_X8000K_1206: {
        value: 1206,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1206',
    },
    V6_X9000K_1207: {
        value: 1207,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1207',
    },
    V6_L8000_1208: {
        value: 1208,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1208',
    },
    V7_E8000_1209: {
        value: 1209,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_1209',
    },
    V6_2910_848: {
        value: 848,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_848',
    },
    V6_5810H_843: {
        value: 843,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_843',
    },
    V6_5320_849: {
        value: 849,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_849',
    },
    V5_5510S_850: {
        value: 850,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_850',
    },
    V6_2000_851: {
        value: 851,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_851',
    },
    V6_X3000_852: {
        value: 852,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_852',
    },
    V6_2200_853: {
        value: 853,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_853',
    },
    V6_2220_854: {
        value: 854,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_854',
    },
    V6_2600_855: {
        value: 855,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_855',
    },
    V6_5110_856: {
        value: 856,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_856',
    },
    V6_5120_857: {
        value: 857,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_857',
    },
    V6_5210_858: {
        value: 858,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_858',
    },
    V6_5220_859: {
        value: 859,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_859',
    },
    V6_2620_861: {
        value: 861,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_861',
    },
    V6_5910_880: {
        value: 880,
        i18n: 'common.EnumDefine_PRODUCT_MODE_E_880',
    },
};
